import { Crisp } from "crisp-sdk-web";

class CrispService {
  private static instance: CrispService;
  private initialized = false;

  private constructor() {}

  public static getInstance(): CrispService {
    if (!CrispService.instance) {
      CrispService.instance = new CrispService();
    }
    return CrispService.instance;
  }

  public init(websiteId: string) {
    if (this.initialized) return;
    
    Crisp.configure(websiteId);
    this.initialized = true;
  }

  public get client() {
    return Crisp;
  }
}

export default CrispService.getInstance(); 